// Carga perezosa de CesiumJS y utilidades del globo. Los mapas base son
// públicos: sin llave de API. Va por CDN porque trae sus propios workers.

const VERSION = '1.118.0';
const CDN = `https://cdnjs.cloudflare.com/ajax/libs/cesium/${VERSION}`;

let carga = null;

export function configuracion() {
  return window.COMANDO_CONFIG || {};
}

export function cargarCesium() {
  if (window.Cesium) return Promise.resolve(window.Cesium);
  if (carga) return carga;

  carga = new Promise((resolve, reject) => {
    const hoja = document.createElement('link');
    hoja.rel = 'stylesheet';
    hoja.href = `${CDN}/Widgets/widgets.css`;
    document.head.appendChild(hoja);

    const script = document.createElement('script');
    script.src = `${CDN}/Cesium.js`;
    script.async = true;
    script.onload = () => {
      // Sin token de Ion: los mapas son de terceros y el terreno es el
      // elipsoide, así que nada de esto pasa por Ion.
      window.Cesium.Ion.defaultAccessToken = '';
      resolve(window.Cesium);
    };
    script.onerror = () => {
      carga = null;
      reject(new Error('No se pudo cargar CesiumJS desde el CDN (revisa la salida a internet).'));
    };
    document.head.appendChild(script);
  });

  return carga;
}

// --- Mapas base --------------------------------------------------------------

export const MAPAS_BASE = [
  { clave: 'satelital', nombre: 'Satélite', icono: 'mdi-satellite-variant' },
  { clave: 'oscuro', nombre: 'Oscuro', icono: 'mdi-weather-night' },
  { clave: 'calles', nombre: 'Calles', icono: 'mdi-road-variant' },
];

export function proveedorBase(Cesium, clave) {
  if (clave === 'oscuro') {
    return new Cesium.UrlTemplateImageryProvider({
      url: 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png',
      subdomains: ['a', 'b', 'c', 'd'],
      credit: '© OpenStreetMap contributors, © CARTO',
    });
  }
  if (clave === 'calles') {
    return new Cesium.UrlTemplateImageryProvider({
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      subdomains: ['a', 'b', 'c'],
      credit: '© OpenStreetMap contributors',
    });
  }
  return new Cesium.UrlTemplateImageryProvider({
    url: 'https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
    credit: 'Imagery © Esri, Maxar, Earthstar Geographics',
  });
}

// --- Geometría ---------------------------------------------------------------

// Caja envolvente en grados: acumula los extremos y los entrega como
// rectángulo para la cámara.
export class Caja {
  constructor() {
    this.oeste = Infinity;
    this.sur = Infinity;
    this.este = -Infinity;
    this.norte = -Infinity;
  }

  extender(lng, lat) {
    if (!Number.isFinite(lng) || !Number.isFinite(lat)) return;
    this.oeste = Math.min(this.oeste, lng);
    this.este = Math.max(this.este, lng);
    this.sur = Math.min(this.sur, lat);
    this.norte = Math.max(this.norte, lat);
  }

  get vacia() {
    return !Number.isFinite(this.oeste) || !Number.isFinite(this.sur);
  }

  get centro() {
    return {
      lat: (this.sur + this.norte) / 2,
      lng: (this.oeste + this.este) / 2,
    };
  }

  // Con aire alrededor: el mínimo evita que un paño chico deje la cámara
  // pegada al suelo, donde ya no se entiende dónde está.
  rectangulo(Cesium, holgura = 0.35, minimoGrados = 0.004) {
    const centro = this.centro;
    const semiLng = Math.max((this.este - this.oeste) / 2, minimoGrados / 2) * (1 + holgura);
    const semiLat = Math.max((this.norte - this.sur) / 2, minimoGrados / 2) * (1 + holgura);
    return Cesium.Rectangle.fromDegrees(
      centro.lng - semiLng,
      centro.lat - semiLat,
      centro.lng + semiLng,
      centro.lat + semiLat,
    );
  }
}

// Recorre las coordenadas de una geometría GeoJSON, por anidada que esté
// (Point, LineString, Polygon, Multi* y GeometryCollection).
export function recorrerCoordenadas(geometria, visita) {
  if (!geometria) return;

  if (geometria.type === 'GeometryCollection') {
    (geometria.geometries || []).forEach((g) => recorrerCoordenadas(g, visita));
    return;
  }

  const bajar = (nodo) => {
    if (!Array.isArray(nodo)) return;
    if (typeof nodo[0] === 'number') {
      visita(nodo[0], nodo[1]);
      return;
    }
    nodo.forEach(bajar);
  };
  bajar(geometria.coordinates);
}

export function pausa(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
